<template>
    <div>
        <multiselect class=""
            :max-height="max_height ? max_height : 300"
            :id="id"
            :loading="isLoading"
            v-model="actual_owner"
            tag-placeholder=""
            placeholder=""
            :options="actual_owner_select"
            :close-on-select="true"
            :clear-on-select="false"
            label="title" track-by="id"
            :taggable="true"
            :selectedLabel="''"
            :placeholder="''"
            :selectLabel="''"
            :deselectLabel="''"
            :tagPlaceholder="''"
            :showNoOptions="false"
            :searchable="true"
            group-values="items"
            group-label="group_name"
        >
            <template slot="option" slot-scope="props">
                <span v-if="props.option.label" class="option__title">{{props.option.label}}</span>
                <span v-if="props.option.$groupLabel" class="option__title">{{props.option.$groupLabel}}</span>
                <span v-if="props.option.title" class="option__title">{{ props.option.title }}</span>

                <a v-if="$hasPermission('car_actual_owners.update') && props.option.id" @click="showEdit(props.option.id)" class="small text-muted">редактировать</a>
            </template>
            <template slot="beforeList" v-if="$hasPermission('car_actual_owners.create')">
                <li class="multiselect__element"><span class="multiselect__option"><a @click="showCreate()" class="option__title">Добавить владельца</a></span></li>
            </template>
        </multiselect>
        <el-dialog :title="form_mode === 'create' ? 'Создание владельца' : 'Редактирование владельца'" :visible.sync="form_state" width="450px" :append-to-body="true">
            <CarActualOwnerForm v-if="form_state" :mode="form_mode" :obj="form_owner" @created="onCreated" @updated="onUpdated"/>
        </el-dialog>
    </div>
</template>

<script>
import CarActualOwnerForm from "./CarActualOwnerForm";
import Multiselect from "vue-multiselect";
import PlatformHelper from "../../helpers/platform";
export default {
    name: "CarActualOwnerSelect",
    components: {CarActualOwnerForm,Multiselect},
    props: ['value', 'id', 'max_height', 'filter_platforms'],
    data: () => ({
        actual_owner: null,
        actual_owners: [],

        form_state: false,
        form_mode: null,
        form_owner: null,
        isLoading: false,
    }),
    mounted() {
        let self = this;

        this.isLoading = true;
        axios.get('/api/car_actual_owners')
            .then(response => {
                self.actual_owners = response.data;
                self.isLoading = false;

                self.actual_owner_select.forEach(group => {
                    group.items.forEach(item => {
                        if (+item.id === +self.value) self.actual_owner = item;
                    })
                })
            });
    },
    watch: {
        actual_owner(val) {
            this.$emit('input', val ? val.id : null);
        },
        value(val) {
            let self = this;
            let i = setInterval(() => {
                if (self.isLoading === false) {
                    clearInterval(i);
                    self.actual_owner_select.forEach(group => {
                        group.items.forEach(item => {
                            if (+item.id === +val) self.actual_owner = item;
                        })
                    })
                }
            }, 1000)
        }
    },
    computed: {
        actual_owner_select() {
            let data = {};
            let only_platforms_ids = this.filter_platforms ? this.filter_platforms : null;
            this.actual_owners.forEach(function (item) {
                if (only_platforms_ids && !only_platforms_ids.includes(item.platform_id)) return;
                if (!data[item.platform_id]) data[item.platform_id] = {group_name: PlatformHelper.get(item.platform_id).name, items: []}
                data[item.platform_id].items.push({
                    id: item.id,
                    title: item.name,
                });
            });
            data = _.mapValues(data, function (item) {
                item.items = _.sortBy(item.items, ['title'])
                return item;
            });
            return _.values(data);
        }
    },
    methods: {
        showEdit(id) {
            this.form_mode = 'edit';
            this.form_owner = _.find(this.actual_owners, {id: id});
            this.form_state = true;
        },
        showCreate() {
            this.form_mode = 'create';
            this.form_state = true;
        },
        onCreated(owner) {
            let self = this;
            this.actual_owners.push(owner);
            this.form_state = false;
            this.actual_owner_select.forEach(group => {
                group.items.forEach(item => {
                    if (item.id === owner.id) self.actual_owner = item;
                })
            })
        },
        onUpdated(owner) {
            let self = this;
            this.form_state = false;
            this.actual_owners = this.actual_owners.map(item => {
                if(item.id === owner.id) item = owner;
                return item;
            })
            this.actual_owner_select.forEach(group => {
                group.items.forEach(item => {
                    if (item.id === owner.id) self.actual_owner = item;
                })
            })
        }
    }
}
</script>

<style scoped>

</style>
